import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';

import { AppRoutes } from '@klp/core/app/config';
import { ActionLink, Block, Heading } from '@klp/design';
import { Main } from '@klp/layout';

export const SakConfirmation: React.FC = () => {
    const { t } = useTranslation();
    return (
        <Main>
            <Grid container={true}>
                <Grid item={true} sm={10} md={8}>
                    <Block paddingTop="bulky" paddingBottom="bulky">
                        <Heading
                            klpHeadingLevel="TWO"
                            translation="sak.confirmation.title"
                        />
                        <Block paddingTop="compact">
                            <p>{t('sak.confirmation.message')}</p>
                        </Block>
                        <Block paddingTop="bulky">
                            <ActionLink
                                actionType="linkBack"
                                translation="general.goBackToFrontpage"
                                href={AppRoutes.mainPage()}
                            />
                        </Block>
                    </Block>
                </Grid>
            </Grid>
        </Main>
    );
};
